"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/LRFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_137)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_137`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 0H35.64V24H-0.359985V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 0H35.64V2.18246H-0.359985V0ZM-0.359985 4.36491H35.64V6.54737H-0.359985V4.36491ZM-0.359985 8.73684H35.64V10.9193H-0.359985V8.73684ZM-0.359985 13.1088H35.64V15.2912H-0.359985V13.1088ZM-0.359985 17.4947H35.64V19.6772H-0.359985V17.4947ZM-0.359985 21.8175H35.64V24H-0.359985V21.8175Z",
					fill: "#BF0A30"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.359985 0H10.5593V10.9193H-0.359985V0Z",
					fill: "#002868"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.09966 2.11932L5.85054 4.4281H8.27861L6.3137 5.85967L7.06458 8.16845L5.09966 6.74388L3.13475 8.16845L3.88563 5.85967L1.92072 4.4281H4.34879L5.09966 2.11932Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_137`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as LRFlag };
